import http from "../common/http-common";
import IDashboardTotal from "../../Interfaces/IDashboardTotal";

class Dashboard$Clasificacion$DataService {
    DashboardInvoices(Mode: number) {
    return http.get<IDashboardTotal>(`/AmazonInvoice/DashboardInvoices?Mode=${Mode}`);
  }
}
export default new Dashboard$Clasificacion$DataService();